import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaStar, FaRegStar } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';


export function TransactionModal({ setShowTransactionModal, getData, pageData }) {
  const {userProfile, logOutFunction} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();
  const [formFields, setFormFields] = useState({});

  const handleSubmit = async () => {
    const formData = new FormData();
    Object.entries(formFields).forEach(([key, value]) => {
        formData.append(key, value);
    });
    setLoading(true)
    try {
        const response = await axios.post(base_url + '/record-transaction.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                accountid: cookies?.userProfile?.main_id,
            },
        });
        if (response.data.code == 403) {
            logOutFunction()
        }
        if (response.data.status) {
            setTostMessage({
                messageType: 'success',
                message: response.data.message
            })
            getData();
            setShowTransactionModal(false);
        } else {
        setTostMessage({
            messageType: 'error',
            message: response.data.message
        })
        }
        setLoading(false)
    } catch (error) {
        setLoading(false)
        setTostMessage({
            messageType: 'error',
            message: 'Network Error'
        })
    }
  };

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div className='w-[80%] flex justify-end text-underline text-[#ff0000]'>
                    <p className='cursor-pointer' onClick={() => setShowTransactionModal(false)}>Cancel</p>
                </div>
                <a className='text-dark text-[15px] font-bold'>Record Transaction</a>
                 <select
                    className="w-[80%] mx-auto border p-2 rounded my-2"
                    // value={formFields?.apt_id}
                    onChange={(e) => setFormFields({...formFields, branch_id: e.target.value})}
                  >
                    <option value="">Choose branch</option>
                    {pageData?.branches?.map((item, index) => 
                        <option key={index} value={item.branch_id}>{item.branch_name}</option>
                    )}
                  </select>
                  <select
                    className="w-[80%] mx-auto border p-2 rounded my-2"
                    // value={formFields?.apt_id}
                    onChange={(e) => setFormFields({...formFields, apt_id: e.target.value})}
                  >
                    <option value="">Choose apartment</option>
                    {pageData?.apartments?.map((item, index) => 
                        <option key={index} value={item.apt_id}>{item.apt_name}</option>
                    )}
                  </select>
                 <select
                    className="w-[80%] mx-auto border p-2 rounded my-2"
                    value={formFields?.transaction_type}
                    onChange={(e) => setFormFields({...formFields, transaction_type: e.target.value})}
                  >
                    <option value="">Choose transaction type</option>
                    <option value="CREDIT">CREDIT Transaction</option>
                    <option value="DEBIT">DEBIT Transaction</option>
                  </select>
                  <input type='number' onChange={(e) => setFormFields({...formFields, transaction_amount: e.target.value})} className="w-[80%] mx-auto border p-2 rounded my-2" placeholder="Transaction Amount" />
                  <textarea
                    className="my-4 w-[80%] mx-auto border border-gray-300 rounded-lg p-3 h-28 outline-none focus:border-blue-500"
                    placeholder={`Narration...(optional)`}
                    value={formFields?.narration}
                    onChange={(e) => setFormFields({...formFields, narration: e.target.value})}
                  />
                  <div className="flex justify-between mt-5">
                        <button
                            onClick={handleSubmit}
                            className="
                            bg-[#037684] text-white rounded-full font-semibold
                            px-8 py-3 transition hover:bg-primary
                            w-full md:w-auto md:self-center
                            "
                        >
                            Save Transaction
                        </button>
                    </div>
                {loading ? (
                    <ClockLoader
                        color={'#212121'}
                        loading={loading}
                        size={25}
                        className='mt-3'
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    ) : null
                }
            </div>  
        </div>
    )
}

